// extracted by mini-css-extract-plugin
export default {"ScrollDownButton":"ScrollDownButton_ScrollDownButton__gowix"};